'use client';

import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@/primitives';
import BreedplanInterpretationInfoModal from './BreedplanInterpretationInfoModal';

type BreedplanInterpretationInfoTriggerProps = {
  /** When false, renders nothing. */
  show?: boolean;
  tooltip?: string;
  ariaLabel?: string;
  dataDdActionName?: string;
  iconSize?: number;
  /** Optional label shown beside the icon. */
  label?: string;
};

export default function BreedplanInterpretationInfoTrigger({
  show = true,
  tooltip = 'How to interpret and use BREEDPLAN information',
  ariaLabel = 'How to interpret and use BREEDPLAN information. Opens explanation dialog.',
  dataDdActionName = 'BREEDPLAN Interpretation Info',
  iconSize = 18,
  label,
}: BreedplanInterpretationInfoTriggerProps) {
  const [open, setOpen] = useState(false);

  if (!show) {
    return null;
  }

  const iconButton = (
    <IconButton
      size="small"
      aria-label={ariaLabel}
      data-dd-action-name={dataDdActionName}
      onClick={() => setOpen(true)}
      sx={{
        p: 0.25,
        color: 'text.secondary',
        flexShrink: 0,
        '&:hover': { color: 'text.primary' },
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: iconSize }} />
    </IconButton>
  );

  return (
    <>
      {label ? (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            minWidth: 0,
          }}
        >
          <Tooltip title={tooltip} placement="top">
            {iconButton}
          </Tooltip>
          <Typography
            component="span"
            variant="bodysmall"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              userSelect: 'none',
            }}
          >
            {label}
          </Typography>
        </Box>
      ) : (
        <Tooltip title={tooltip} placement="top">
          {iconButton}
        </Tooltip>
      )}
      <BreedplanInterpretationInfoModal
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
